module.exports = __webpack_public_path__ + "R6eBuddyPass_oct2021_619x326_x2_FR-FRA.jpg";